import { createFileRoute, redirect } from "@tanstack/react-router";

/** Legacy slug — permanent redirect to the canonical EN URL. */
export const Route = createFileRoute("/lemon-thermometer")({
  beforeLoad: () => {
    throw redirect({ to: "/en/leak-detector", statusCode: 301 });
  },
});
